import { createApp } from 'vue';
import App from '~/App.vue';
import { installPlugins } from '~/plugins';

// > Vue init
const app = createApp(App);
// > Install plugins
installPlugins(app);
// > Vue mount
app.mount('#app');
